// extracted by mini-css-extract-plugin
module.exports = {"widgetsSection":"WidgetsSection_widgetsSection__1-mm0"};